import script from "./editMedicInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./editMedicInfo.vue?vue&type=script&setup=true&lang=ts"

import "./editMedicInfo.vue?vue&type=style&index=0&id=fa901d8c&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa901d8c"]])

export default __exports__